import { Controller } from 'stimulus';
import googleMapSilver from '../../../shared/assets/javascript/google_map_silver_styles';

export default class extends Controller {
  static targets = ['map'];

  state = { isLoaded: window.google || false };

  get mapEl() {
    return document.querySelector('.hotel__info--map');
  }

  get apiKey() {
    return this.mapEl.querySelector('[data-api-key]').dataset.apiKey;
  }

  get svgSolidNeighborhoodMarker() {
    return {
      anchor: new google.maps.Point(15, 70),
      fillColor: '#000000',
      fillOpacity: 1,
      labelOrigin: new google.maps.Point(18, 20),
      path: 'M18.1220562,0 C8.10979373,0 0,8.07961165 0,18.0546117 C0,28.0296117 7.9292675,39.609466 18.1220562,57 C28.3148449,39.609466 36.2441124,28.0296117 36.2441124,18.0546117 C36.2441124,8.07961165 28.1343187,0 18.1220562,0 L18.1220562,0 Z',
      scale: 0.7,
      strokeColor: '#000000',
    };
  }

  get svgSolidSingleListingMarker() {
    return {
      anchor: new google.maps.Point(15, 70),
      fillColor: '#000000',
      fillOpacity: 1,
      labelOrigin: new google.maps.Point(18, 20),
      path: 'M348 469.333c-70.699 0-128-57.301-128-128s57.259-128 128-128c70.741 0 128 57.301 128 128s-57.301 128-128 128zM348 0c-179.115 0-341.333 145.195-341.333 324.352 0 266.368 272.085 294.528 341.333 699.648 69.248-405.12 341.333-433.28 341.333-699.648 0-179.157-162.176-324.352-341.333-324.352z',
      scale: 0.04,
      strokeColor: '#000000',
    };
  }

  get svgOpaqueNeighborhoodMarker() {
    return {
      anchor: new google.maps.Point(15, 70),
      fillColor: '#000000',
      fillOpacity: 0.3,
      labelOrigin: new google.maps.Point(18, 20),
      path: 'M18.1220562,0 C8.10979373,0 0,8.07961165 0,18.0546117 C0,28.0296117 7.9292675,39.609466 18.1220562,57 C28.3148449,39.609466 36.2441124,28.0296117 36.2441124,18.0546117 C36.2441124,8.07961165 28.1343187,0 18.1220562,0 L18.1220562,0 Z',
      scale: 0.7,
      strokeColor: '#000000',
      strokeWeight: 0.1,
    };
  }

  connect() {
    this.appendScript();
  }

  appendScript() {
    const googleMapScript = document.createElement('script');
    googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&libraries=places,geometry&callback=initMap`;
    googleMapScript.type = 'text/javascript';
    googleMapScript.async = true;
    window.initMap = () => this.initMap();
    document.head.appendChild(googleMapScript);
  }

  initMap() {
    if (this.mapEl.childElementCount > 0) {
      let markerEls = this.mapEl.querySelectorAll('.marker');
      const args = {
        zoom: 12,
        center: new google.maps.LatLng(0, 0),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: false,
        scrollwheel: false,
      };

      this.googleMap = new google.maps.Map(this.mapEl, args);
      this.googleMap.markers = [];
      markerEls.forEach((markerEl) => this.addMarker(markerEl, this.mapEl));
      this.centerMap(markerEls);
      this.googleMap.setOptions({ styles: googleMapSilver.styles_list });
    }
  }

  addMarker(markerEl) {
    const latlng = new google.maps.LatLng(markerEl.getAttribute('data-lat'), markerEl.getAttribute('data-lng'));
    const pin = {
      url: markerEl.getAttribute('data-icon'),
      size: new google.maps.Size(70, 100),
      anchor: new google.maps.Point(17, 50),
      scaledSize: new google.maps.Size(33, 50),
      labelAnchor: new google.maps.Point(0, 0),
      labelClass: 'label',
    };

    let googleMapMarker = new google.maps.Marker({
      position: latlng,
      map: this.googleMap,
      draggable: false,
      icon: pin,
    });

    this.googleMap.markers.push(googleMapMarker);

    if (markerEl.innerHTML) {
      const infowindow = new google.maps.InfoWindow({
        content: markerEl.innerHTML,
      });
      google.maps.event.addListener(googleMapMarker, 'click', () => {
        infowindow.open(this.mapEl, googleMapMarker);
      });
    }
  }

  centerMap() {
    let bounds = new google.maps.LatLngBounds();
    this.googleMap.markers.forEach((marker) => {
      const latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
      bounds.extend(latlng);
    });

    if (this.googleMap.markers.length === 1) {
      this.googleMap.setCenter(bounds.getCenter());
      this.googleMap.setZoom(16);
    } else {
      this.googleMap.fitBounds(bounds);
    }
  }
}
